import styled from "styled-components";

export const ProductWrapper = styled.div`
  .card {
    border-color: transparent;
    transition: 0.3s all;
  }

  .card-footer {
    background: transparent;
    border-top: transparent;
    transition: 0.3s all;
  }

  .img-container {
    position: relative;
    overflow: hidden;

    .card-img-top {
      transition: 1s all;
    }

    &:hover .card-img-top {
      transform: scale(1.2);
    }
  }

  .cart-btn {
    position: absolute;
    bottom: 1rem;
    right: 1rem;
    transform: translate(150%, 150%);
    transition: all 0.5s;
    border: 1px solid #333;

    .add-icon {
      transition: all 0.5s;
    }

    :hover {
      border-color: var(--mainYellow);

      .add-icon {
        color: var(--mainYellow);
      }
    }
  }

  &:hover {
    .card {
      border: 0.04rem solid rgba(0, 0, 0, 0.2);
      box-shadow: 2px 2px 5px 0px rgba(0, 0, 0, 0.2);

      .cart-btn {
        transform: translate(0, 0);
      }
    }

    .card-footer {
      color: blue;
    }
  }
`;
